import React, { useState, useCallback } from "react";
import AdminNav from "../AdminNav";
import Footer from "../../Footer";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import PlanList from "./Plan/PlanList";
import InstituteList from "./Institute/InstituteList";
import Navbar from "../../Navbar";

const ManageInstitute = () => {
  const [alignment, setAlignment] = useState("plan");

  const handleToggleChange = useCallback((event, newAlignment) => {
    if (newAlignment !== null) setAlignment(newAlignment);
  }, []);

  const renderContent = {
    plan: <PlanList />,
    institute: <InstituteList />,
  };

  return (
    <>
      <AdminNav />
      {/* <Navbar MemberType={MemberTyp} /> */}
      <div className="main-content-gap">
        <h2 className="topHeading">Institute Management</h2>

        <div className="container">
          <Box sx={{ textAlign: "center" }}>
            <ToggleButtonGroup
              color="primary"
              value={alignment}
              exclusive
              onChange={handleToggleChange}
              aria-label="Institute management toggle"
              sx={{ mb: 2, width: "100%" }}
            >
              <ToggleButton value="plan" sx={{ flex: 1 }}>
                Plan
              </ToggleButton>
              <ToggleButton value="institute" sx={{ flex: 1 }}>
                Institute
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
          {renderContent[alignment]}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ManageInstitute;
